/// Base Actions - calling external API
import { AxiosResponse } from "axios";
import _keys from "lodash.keys";
import { apiClient } from "./apiClient";
import { resolveApiUrl } from "./apiUrl";

export { resolveApiUrl as fullEndpoint } from "./apiUrl";

export interface ErrorType {
  id: string;
  intlId: string;
  defaultMessage: string;
}

export interface DataWrapper<T> {
  data?: T;
}

/// Get from endpoint (optional `params` are serialized as query string by axios)
const get = <T,>(endpoint: string, params?: Record<string, unknown>) => {
  return apiClient.get<any, AxiosResponse<T>>(
    resolveApiUrl(endpoint),
    params !== undefined ? { params } : undefined
  );
};

/// get Blob from endpoint
const getBlob = (endpoint: string) => {
  return apiClient.get(resolveApiUrl(endpoint), { responseType: "blob" });
};

/// post data to endpoint
const post = (endpoint: string, data: any) => {
  return apiClient.post(resolveApiUrl(endpoint), data);
};

/// post file data to endpoint
const postFile = (endpoint: string, data: any) => {
  const formData = new FormData();
  const keys = _keys(data);
  const cfg = getConfig({ "content-type": "multipart/form-data" });

  keys.forEach((k: any) => {
    formData.append(k, data[k]);
  });

  return apiClient.post(resolveApiUrl(endpoint), formData, cfg);
};

/// post file data to endpoint
const putFile = (endpoint: string, data: any) => {
  const formData = new FormData();
  const keys = _keys(data);
  const cfg = getConfig({ "content-type": "multipart/form-data" });

  keys.forEach((k: any) => {
    formData.append(k, data[k]);
  });

  return apiClient.put(resolveApiUrl(endpoint), formData, cfg);
};

/// put data to endpoint
const put = (endpoint: string, data: any) => {
  return apiClient.put(resolveApiUrl(endpoint), data);
};

/// delete endpoint
const del = (endpoint: string) => {
  return apiClient.delete(resolveApiUrl(endpoint));
};

/// create general http request
const request = (reqConfig: any) => {
  const newConfig = { ...getConfig(), ...reqConfig };
  return apiClient.request(newConfig);
};

/// Private Functions
const getConfig = (overrideParams = {}) => {
  return {
    ...overrideParams,
  };
};

const customizeError = (err: any, customProperties: ErrorType) => {
  err.id = customProperties.id;
  err.message = customProperties.defaultMessage;
  err.body = customProperties;

  return err;
};

export {
  get,
  getBlob,
  post,
  postFile,
  put,
  putFile,
  del,
  request,
  customizeError,
};
